import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { saveToken, clearToken, getToken } from "@/lib/api";
import { clearUser as clearOfflineQueue } from "@/lib/offlineQueue";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      setLoading(false);
      return;
    }
    fetchMe();
  }, [fetchMe]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    saveToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    // Tur 2.5B: farklı hesabın offline kuyruğuna sızma olmasın diye
    // bu kullanıcının bekleyen mesajlarını temizle.
    try {
      const uid = (typeof user === "object" && user) ? user.id : null;
      if (uid) clearOfflineQueue(uid).catch(() => {});
    } catch { /* noop */ }
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
